import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GetParams,
  GetResponse,
  UnitOfMeasureCategory,
  UnitOfMeasureCategoryCreate,
  PostResponse,
  User,
  UserCreate,
} from '@app/shared';
import { convertGetParamsToHttpParams } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureCategoryService {
  /** URLs principales relacionadas con UnitOfMeasureCategorys **/
  UnitOfMeasureCategoryUrl =
    environment.coreApiBaseUrl + '/api/unitofmeasurecategory';
  UnitOfMeasureCategoryTypeUrl =
    environment.coreApiBaseUrl + '/api/unitofmeasurecategory-type';
  userUrl = environment.identityApiBaseUrl + '/api/user';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar UnitOfMeasureCategorys **/
  getUnitOfMeasureCategory(
    getParams: GetParams,
    accessToken?: string
  ): Observable<GetResponse> {
    let headers = new HttpHeaders();

    // Si el accessToken es proporcionado, agregamos el header Authorization
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    // Realizamos la petición GET con los parámetros y, si es necesario, con el token de autorización
    return this.http.get<GetResponse>(this.UnitOfMeasureCategoryUrl, {
      params: convertGetParamsToHttpParams(getParams),
      headers: headers, // Pasamos los headers
    });
  }

  createUnitOfMeasureCategory(
    newUnitOfMeasureCategory: UnitOfMeasureCategoryCreate
  ): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      this.UnitOfMeasureCategoryUrl,
      newUnitOfMeasureCategory
    );
  }

  updateUnitOfMeasureCategory(
    UnitOfMeasureCategory: UnitOfMeasureCategory
  ): Observable<any> {
    return this.http.put(this.UnitOfMeasureCategoryUrl, UnitOfMeasureCategory);
  }

  deleteUnitOfMeasureCategory(
    UnitOfMeasureCategorysIds: number[]
  ): Observable<any> {
    return this.http.delete(this.UnitOfMeasureCategoryUrl, {
      body: { ids: UnitOfMeasureCategorysIds },
    });
  }

  /** Metodos de obtener/crear/actualizar/eliminar UnitOfMeasureCategoryTypes **/
  getUnitOfMeasureCategoryType(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.UnitOfMeasureCategoryTypeUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createUnitOfMeasureCategoryType(newUnitOfMeasureCategoryType: {
    name: string;
    isActive: boolean;
  }): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      this.UnitOfMeasureCategoryTypeUrl,
      newUnitOfMeasureCategoryType
    );
  }

  updateUnitOfMeasureCategoryType(UnitOfMeasureCategoryType: {
    id: number;
    name: string;
    isActive: boolean;
  }): Observable<any> {
    return this.http.put(
      this.UnitOfMeasureCategoryTypeUrl,
      UnitOfMeasureCategoryType
    );
  }

  deleteUnitOfMeasureCategoryType(
    UnitOfMeasureCategoryTypesIds: number[]
  ): Observable<any> {
    return this.http.delete(this.UnitOfMeasureCategoryTypeUrl, {
      body: { ids: UnitOfMeasureCategoryTypesIds },
    });
  }

  /** Metodos de obtener/crear/actualizar/eliminar User **/
  getUser(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userUrl, {
      params: convertGetParamsToHttpParams(getParams),
    });
  }

  createUser(newUser: UserCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userUrl, newUser);
  }

  updateUser(User: User): Observable<any> {
    return this.http.put(this.userUrl, User);
  }

  deleteUser(desconsolidationsTypeIds: number[]): Observable<any> {
    return this.http.delete(this.userUrl, {
      body: { ids: desconsolidationsTypeIds },
    });
  }
}
